import Link from 'components/Basic/Link/Link';
import { LegalGuaranteeNoticeLink } from 'components/Blocks/LegalGuaranteeNotice/LegalGuaranteeNoticeLink';
import { useDomainConfig } from 'context/DomainConfigProvider/DomainConfigProvider';
import { B2C_CZ_DOMAIN_ID, B2C_SK_DOMAIN_ID, isDomain, isDomainLocale } from 'helpers/isDomainLocale';
import Trans from 'next-translate/Trans';
import useTranslation from 'next-translate/useTranslation';
import { getInternationalizedStaticUrls } from 'utils/getInternationalizedStaticUrls';

const TEST_IDENTIFIER = 'layout-footer-footercopyright';

const footerCopyrightTextClassName = 'text-small tracking-wider text-grayDark mb-0 leading-loose [font-weight:inherit]';

const WEB_PRODUCER_URLS = {
    czech: 'https://www.shopsys.cz',
    other: 'https://www.shopsys.com',
};

const FooterCopyright: FC = () => {
    const { url, defaultLocale, domainId: currentDomainId } = useDomainConfig();
    const { t } = useTranslation();
    const [GdprUrl] = getInternationalizedStaticUrls(['/gdpr'], url);
    const [cookieConsentUrl] = getInternationalizedStaticUrls(['/cookie-consent'], url);
    const isCzechLocale = isDomainLocale(defaultLocale, 'cs');

    return (
        <div className="flex flex-col items-center text-center" data-testid={TEST_IDENTIFIER}>
            <p className={footerCopyrightTextClassName}>
                {t('Copyright © 1992–2021, TESCOMA s.r.o. All rights reserved.')}
            </p>
            <p className={footerCopyrightTextClassName}>
                <Trans
                    defaultTrans="This website uses cookies. <lnk1>More information</lnk1> about the files."
                    i18nKey="footer-terms"
                    components={{
                        lnk1: <Link className="h-6 text-inherit" href={GdprUrl} linkType="external" target="_blank" />,
                    }}
                />
            </p>
            <p className={footerCopyrightTextClassName}>
                <LegalGuaranteeNoticeLink className="h-6 text-small text-inherit" />
            </p>
            <p className={footerCopyrightTextClassName}>
                {!isDomain(currentDomainId, B2C_CZ_DOMAIN_ID) && !isDomain(currentDomainId, B2C_SK_DOMAIN_ID) && (
                    <Link className="h-6 text-inherit" href={cookieConsentUrl}>
                        {t('Cookie consent update')}
                    </Link>
                )}
            </p>
            <div className="mt-8 flex items-center vl:mt-14">
                <p className={footerCopyrightTextClassName}>{t('Professional customized eshop')}</p>
                <a
                    className="ml-3 inline-flex flex-shrink-0 text-inherit vl:ml-8"
                    href={isCzechLocale ? WEB_PRODUCER_URLS.czech : WEB_PRODUCER_URLS.other}
                    rel="noreferrer"
                    tabIndex={0}
                    target="_blank"
                >
                    <img alt="ShopSys" height={18} src="/images/logo-shopsys.svg" width={77} />
                </a>
            </div>
        </div>
    );
};

/* @component */
export default FooterCopyright;
